import React from 'react';
import { useUI } from '../contexts/UIContext';
import withTranslation from '../hoc/withTranslation';
import StatisticsPanel from '../components/Stats/StatisticsPanel';
import PageLayout from '../components/PageLayout';
import { SCREENS } from '../utils/constants';

/**
 * Statistics Dashboard Screen Component
 * This screen displays user statistics and analytics
 */
const StatisticsDashboard = ({ t }) => {
  const { isDarkMode, navigateToScreen } = useUI();
  
  // Handle navigation back to dashboard
  const handleNavigateBack = () => {
    navigateToScreen(SCREENS.DASHBOARD);
  };  
  
  return (
    <PageLayout
      title={t('common.statistics', 'Statistics')}
      showBackButton={true}
      onBackClick={handleNavigateBack}
    >
      <div className="w-full h-full overflow-y-auto">
        <StatisticsPanel isDarkMode={isDarkMode} />
      </div>
    </PageLayout>
  );
};

export default withTranslation(StatisticsDashboard);
